import { render, staticRenderFns } from "./Footbar.vue?vue&type=template&id=1c612cdd&lang=html"
import script from "./Footbar.vue?vue&type=script&lang=js"
export * from "./Footbar.vue?vue&type=script&lang=js"
import style0 from "./Footbar.vue?vue&type=style&index=0&id=1c612cdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports